/** The Leaflet path class that `assets/alertMapEditor.scss` draws in the danger color. */
export const OUTSIDE_AREA_PATH_CLASS = 'alert-map-editor-outside-area';

/** The map tooltip on a shape outside the authorized area. */
export const OUTSIDE_AREA_TOOLTIP = 'Outside the authorized area';

/**
 * Changes the path options of a shape outside the authorized area: the danger color (from the
 * class), a light fill of that color, and a dashed line, so the mark does not rely on color only.
 * Leaflet reads `className` only when it creates the path, so the caller remounts the shape when
 * this state changes.
 * @param {object} pathOptions The normal path options of the shape.
 * @returns {object} The path options for a shape outside the area.
 */
export const getOutsideAreaPathOptions = (pathOptions) => ({
  ...pathOptions,
  className: OUTSIDE_AREA_PATH_CLASS,
  fillOpacity: 0.18,
  opacity: 1,
  dashArray: '6 6',
});
